import { FINES } from '@accra/shared';

export type { Junction } from './routes';

/**
 * Signal timing for our road, seconds. The crossing road gets green during our red, then amber, then an
 * all-red clearance so anyone already in the junction is out before we get green.
 */
export const SIGNAL = { green: 9, amber: 3, red: 11 } as const;
export const CROSS_SIGNAL = { amber: 2.5, allRed: 2.5 } as const;

/** Half the width of the crossing road. */
export const CROSS_ROAD_HALF = 8;
/** Our stop line sits this far before the junction centre. */
export const STOP_LINE_OFFSET = 10;
/** Cross traffic stops at these x positions when their light is red (left of the far kerb, right of our kerb). */
export const CROSS_STOP_X = { fromLeft: -24, fromRight: 12.5 } as const;
/** Cross-road lane centres, offset from the junction centre along our road. */
export const CROSS_LANES = { eastbound: [2, 5.4], westbound: [-2, -5.4] } as const;
/** Pedestrians cross our carriageway on the near zebra, between the kerb and the median. */
export const ZEBRA = {
  kerbX: 6.4,
  medianX: -6.2,
  /** Only start crossing in the first seconds of our red, so they're clear before green. */
  startWindow: 1.6,
  speed: [1.8, 2.2] as const,
  maxPerRed: 6,
} as const;
/** Fine for jumping a red light, pesewas. */
export const RED_LIGHT_FINE = FINES.redLight;
